import { CIVIL_PARTY } from 'containers/data-structure';
import { CivilParty } from 'containers/LawyerLegalProceedingsPage/judgementAdd/CivilParty/constants';

import validate, { validateFormFields } from 'containers/services/validateForm';
import { isEmpty } from 'lodash';

export const civilPartyDocumentConstraints = {
  [CIVIL_PARTY.URL]: {
    presence: true,
  },
  [CIVIL_PARTY.TYPE]: {
    presence: true,
  },
  [CIVIL_PARTY.NAME]: {
    presence: true,
  },
};

export const civilPartyDocumentsValidator = (civilParty: CivilParty) => {
  return validate(civilParty, civilPartyDocumentConstraints);
};

export const isCivilPartyFormValidated = (
  civilPartyDocument: CivilParty,
): boolean => {
  const isCivilDocumentValidated = validateFormFields(
    civilPartyDocumentsValidator(civilPartyDocument),
  );

  return isCivilDocumentValidated && !isEmpty(civilPartyDocument.victims);
};
